module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project_item"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "project_item--body"
  }, [_c('h4', {
    staticClass: "project_anchor project_item--name",
    attrs: {
      "data-anchor-id": _vm.project.id
    }
  }, [_vm._v("\n            " + _vm._s(_vm.project.name) + "\n          ")]), _vm._v(" "), _c('table', {
    staticClass: "project_item--details"
  }, [_c('caption', {
    staticClass: "sr-only"
  }, [_vm._v("Project Technical Details")]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "project_item--details__label",
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Client")]), _vm._v(" "), _c('td', {
    staticClass: "project_item--details__client"
  }, [_vm._v(_vm._s(_vm.project.client))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "project_item--details__label",
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Role")]), _vm._v(" "), _c('td', {
    staticClass: "project_item--details__role"
  }, [_vm._v(_vm._s(_vm.project.role))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "project_item--details__label",
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Tech")]), _c('td', {
    staticClass: "project_item--details__tech"
  }, _vm._l((_vm.project.technology), function(item) {
    return _c('span', {
      key: item
    }, [_vm._v(_vm._s(item) + ", ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "project_item--content"
  }, [(_vm.project.description) ? _c('project-item-description-item', {
    attrs: {
      "label": "Description",
      "content": _vm.project.description
    }
  }) : _vm._e(), _vm._v(" "), (_vm.project.challenges) ? _c('project-item-description-item', {
    attrs: {
      "label": "Challenges",
      "content": _vm.project.challenges
    }
  }) : _vm._e(), _vm._v(" "), (_vm.project.solution) ? _c('project-item-description-item', {
    attrs: {
      "label": "Solution",
      "content": _vm.project.solution
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.project.media.animation) ? [(_vm.project.media.animation.frame === 'iPad') ? _c('div', {
    staticClass: "project_item--preview"
  }, [_c('div', {
    staticClass: "container project_item--preview-item animation--iPad"
  }, [_c('project-tablet', {
    attrs: {
      "image": _vm.project.media.animation.image,
      "name": _vm.project.name
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.project.media.animation.frame === 'macbook') ? _c('div', {
    staticClass: "project_item--preview"
  }, [_c('div', {
    staticClass: "container project_item--preview-item animation--macbook"
  }, [_c('project-macbook', {
    attrs: {
      "image": _vm.project.media.animation.image,
      "name": _vm.project.name
    }
  })], 1)]) : _vm._e()] : (_vm.project.media.preview) ? [(_vm.project.media.preview) ? _c('div', {
    staticClass: "project_item--preview"
  }, [_c('img', {
    staticClass: "project_item--preview-item",
    attrs: {
      "src": _vm.project.media.preview,
      "alt": 'Image of project with ' + _vm.project.name
    }
  })]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), (_vm.project.testimonial[0]) ? [_c('project-testimonial', {
    attrs: {
      "id": _vm.project.id,
      "link": _vm.project.testimonial[0].link,
      "quote": _vm.project.testimonial[0].quote,
      "name": _vm.project.testimonial[0].name,
      "role": _vm.project.testimonial[0].role,
      "image": _vm.project.testimonial[0].image
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-306fd2d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/partials/project-item/ProjectItem.vue
// module id = 83
// module chunks = 0